<script lang="ts" setup>
import { AppLink } from '#components'

const { loadLayout, layoutData } = useLayout()
await loadLayout()

const getElement = (to: string | null | undefined) => {
  return to ? AppLink : 'span'
}

const year = new Date().getFullYear()

const { breakpoint } = useApp()

const showAll = ref(true)

onMounted(() => {
  watchEffect(() => {
    showAll.value = !['mobile', 'phablet', 'tablet', 'desktop'].includes(breakpoint.value)
  })
})
</script>

<template>
  <footer class="footer">
    <div class="footer__container">
      <AppNewsletter class="footer__newsletter" />

      <AppSocials class="footer__socials" />

      <AppContact class="footer__contact" />

      <div class="footer__menu">
        <UiCollapsable
          v-if="layoutData?.service?.[0]"
          :key="`service-${showAll}`"
          :label="layoutData.service[0].Title"
          :open="showAll"
          class="footer__menu--service"
        >
          <template #icon_after="{ open }">
            <Icon
              :name="open ? 'icon:min' : 'icon:plus'"
              class="collapsable__icon"
            />
          </template>

          <ul
            v-if="layoutData?.service?.[0]?.Links?.length"
            class="unstyled"
          >
            <li
              v-for="(group, index) in layoutData.service[0].Links"
              :key="index"
            >
              <component
                :is="getElement(group.Link)"
                v-if="group.Name"
                :to="group.Link"
              >
                {{ group.Name }}
              </component>
            </li>
          </ul>
        </UiCollapsable>

        <UiCollapsable
          v-if="layoutData?.advice?.[0]"
          :key="`advice-${showAll}`"
          :label="layoutData.advice[0].Title"
          :open="showAll"
          class="footer__menu--advice"
        >
          <template #icon_after="{ open }">
            <Icon
              :name="open ? 'icon:min' : 'icon:plus'"
              class="collapsable__icon"
            />
          </template>
          <ul
            v-if="layoutData?.advice?.[0]?.Links?.length"
            class="unstyled"
          >
            <li
              v-for="(group, index) in layoutData.advice[0].Links"
              :key="index"
            >
              <component
                :is="getElement(group.Link)"
                v-if="group.Name"
                :to="group.Link"
              >
                {{ group.Name }}
              </component>
            </li>
          </ul>
        </UiCollapsable>
      </div>

      <div class="footer__icons--mobile">
        <div class="footer__icons--desktop">
          <AppPaymentIcons class="footer__payment-icons" />

          <Icon name="icon:labels-cbw" />
        </div>

        <div class="footer__label">
          <img
            class="hofleverancier"
            src="/images/bij-koninklijke-beschikking-hofleverancier.png"
            alt="Bij Koninklijke Beschikking Hofleverancier Bouman-Potter B.V."
            loading="lazy"
            height="356"
            width="270"
          >
        </div>
      </div>

      <div class="footer__copyright">
        &copy; Copyright {{ year }} {{ $t('meta.name') }}
      </div>

      <div
        v-if="layoutData?.legal?.[0]"
        class="footer__legal"
      >
        <strong class="footer__legal-title">
          {{ layoutData?.legal[0].Title }}
        </strong>
        <ul class="footer__legal-list">
          <li
            v-for="(group, index) in layoutData?.legal[0]?.Links"
            :key="index"
          >
            <component
              :is="getElement(group.Link)"
              v-if="group.Name"
              :to="group.Link"
            >
              {{ group.Name }}
            </component>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<style>
@import url("~layers/app/components/App/Footer.css");
</style>
